import React from 'react';
import ImportPage from '@/components/import/ImportPage';

export default function ImportIndexPage() {
  return <ImportPage />;
}
